import React, {useEffect, useState} from "react";
import {Box, Button, Card, Container, TextField} from "@mui/material";
import {PrintOutlined} from "@mui/icons-material";
import {Checkbox} from "../../../components/base/checkbox/checkbox";

export const PrintViewHeaderToolbar = ({showPromotion, setShowPromotion, promotionText, setPromotionText}) => {
    const [localPromotionText, setLocalPromotionText] = useState(promotionText);

    /**
     * With any changes in promotionText from props, updates the localPromotionText state.
     */
    useEffect(() => {
        setLocalPromotionText(promotionText);
    }, [promotionText]);

    return (
        <>
            <Container maxWidth={'lg'} className={'d-print-none'} sx={{position: 'sticky', top: 10, zIndex: 100}}>
                <Card variant={'outlined'} sx={{backgroundColor: 'background.paper'}}>
                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2, width: '100%', gap: 2}}>
                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'flex-start', flexGrow: 1}}>
                            <Checkbox
                                formControlLabelProps={{sx: {margin: 0}}}
                                label={'Show Promotion'}
                                sx={{paddingBlock: 0.75}}
                                disableRipple
                                checked={showPromotion}
                                onChange={(e, checked) => setShowPromotion(checked)}
                            />
                            {
                                showPromotion &&
                                <TextField
                                    size={'small'}
                                    sx={{marginLeft: 1, flexGrow: 1}}
                                    label={'Promotion Text'}
                                    value={localPromotionText}
                                    onChange={(e) => setLocalPromotionText(e.target.value)}
                                    onBlur={() => setPromotionText(localPromotionText)}
                                />
                            }
                        </Box>
                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'flex-end'}}>
                            <Button
                                variant={'contained'}
                                onClick={() => window.print()}
                                sx={{marginRight: 1}}
                                size={'small'}
                                startIcon={<PrintOutlined/>}
                            >
                                Print
                            </Button>
                        </Box>
                    </Box>
                </Card>
            </Container>
        </>
    )
}
